let view = null;

export default {
	namespace: 'template-pillar',
	beforeEnter: async ({ current, next, trigger }) => {
		const { default: PillarView } = await import(
			/* webpackChunkName: "pillar-view" */ '../../templates/PillarView'
		);
		view = new PillarView(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
